import script from "./AdminPagesPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminPagesPanel.vue?vue&type=script&setup=true&lang=js"

import "./AdminPagesPanel.vue?vue&type=style&index=0&id=1ca5018c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ca5018c"]])

export default __exports__